import { Component, Renderer2, ElementRef, OnInit, Input, OnDestroy, ViewChild, ChangeDetectorRef } from "@angular/core";

import { SharedService } from "../../Services/shared.service";
import { WIDGET } from "../../../models/app-json";
import { PAGEI } from "../../../models/page_config_json";
import { ALLOWED_INPUT_WIDGET_TYPES_FOR_LINEITEM_ACTION, PAGETYPES, WIDGET_CLICK_ACTIONS, WIDGET_TYPES, pageTypeCnsts,} from "../../../constants/proj.cnst";
import { ApiconfigService, Charts, isNullOrUndefined, StreamBlobService } from "shared-library";
import { PRE_CONFIGURED_APIS } from "../../widgetPropertyForms/constants/const";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { WIDGETACTION } from "../../widgetPropertyForms/components/widget-actions/models/widget-actions.model";
import { WidgetPropertyFormService } from "../../widgetPropertyForms/widget-property-form.service";
import { ActivatedRoute } from "@angular/router";

declare const WebFont: any;
@Component({
  selector: "lib-widget-filter",
  templateUrl: "./widget-filter.component.html",
  styleUrls: ["./widget-filter.component.scss"],
})
export class WidgetFilterComponent implements OnInit,OnDestroy {
  @Input() widget!: any;
  @Input() sectionIndex!: number;
  @Input() widgetIndex!: number;
  @Input() page!: PAGEI;
  @Input() editPagePermission: boolean = true;

  @ViewChild('imageRef') imageRef!: ElementRef<HTMLImageElement>;
  loading = true;
  relativeWidgets = [];
   widgetTypes = WIDGET_TYPES;
  pageTypes = PAGETYPES;
  widgetClickActions = WIDGET_CLICK_ACTIONS
  displayWidgetCharts: typeof Charts = Charts;
  widgetLabel: string = "";
  widgetId: string = "";
  placeholder: string = "";
  textColor: string = "";
  imageUploaderDefault = "../assets/images/image-placeholder.webp";
  dataSourceApiValues: any = { widgetId: "", responce: [], field: "" };
  selectedHeadFontFamily: string = "Roboto";
  selectedBodyFamily: string = "Roboto";
  s3imageUrl: string = "";
  primaryColor = "#64ff6f";
  onPrimaryColor = "#FFFFFF";
  primaryContainerColor = "#a1a2a2";
  onPrimaryContainerColor = "#143b10";
  themeTextColor!: string;
  serfaceVarient = "";
  currentDate = new Date();
  isDarkTheme!:boolean;
  dataField: any[] = [];
  defaultAvtarImageUrl: string | ArrayBuffer | null = 'assets/imgs/chat-boat-avator-pic.png';
  preConfiguredApis:any = PRE_CONFIGURED_APIS;
  initalLineAction!:any;
  renderTemplateview:any;
  lineItemwidgetsMap:any = {};
  lineitemPageId:string = "";
  showPagesSpinner = false;
  allowedWidgetTypes = ALLOWED_INPUT_WIDGET_TYPES_FOR_LINEITEM_ACTION;
  imageBlob:any;
  imagePath:any;
  destroy$:Subject<void> = new Subject();

  
  constructor(
    private sharedSrv: SharedService,
    private apiConfigService : ApiconfigService,
    private wpserv:WidgetPropertyFormService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private streamBlobService: StreamBlobService

  ) {}

  ngOnInit(): void {
    this.sharedSrv.themesObj.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.selectedHeadFontFamily = isNullOrUndefined(data?.headingFont) ? "Roboto" : data?.headingFont;
      this.selectedBodyFamily = isNullOrUndefined(data?.bodyFont) ? "Roboto" : data?.bodyFont;
      this.primaryColor = data.primaryColor;
      this.onPrimaryColor = data.secondaryColor;
      this.themeTextColor = data.defaultTextColor;
      this.isDarkTheme = data.themeName.toLocaleLowerCase().includes("dark");
    });

    if (this.widget.widgetConfig) {
      if(this.widget.widgetType == this.widgetTypes.imageUploader){
        this.setUpImageUploaderWidget();
      }

      const checkMatUiType = this.widget.widgetConfig && this.widget.widgetConfig.hasOwnProperty("matUiType");
      const allowedButtontypes = [this.widgetTypes.button,this.widgetTypes.printer];
      if (!checkMatUiType) {
          this.widget.widgetConfig["matUiType"] = allowedButtontypes.includes(this.widget.widgetType) ? "filled" : "outlined";
      }
    } 
    if([this.widgetTypes.lineChart,this.widgetTypes.barChart,this.widgetTypes.stackBarChart, this.widgetTypes.fixedBarChart].includes(this.widget.widgetType) && this.widget?.widgetConfig?.chartConfig){
      let chartConfig = this.widget.widgetConfig.chartConfig;
    if(!chartConfig.yAxisProperties.individualSeriesProperties){
      chartConfig.yAxisProperties = {
        "label": chartConfig.yAxisProperties.label,
        "series":  chartConfig.yAxisProperties.series.map((item:any) => item.key),
        "individualSeriesProperties": chartConfig.yAxisProperties.series,
        "dataLabels":chartConfig?.yAxisProperties?.dataLabels,
        "stackLabels": chartConfig?.yAxisProperties?.stackLabels
        };
      }
    }

    if(this.page.pageType === this.pageTypes.dataListView){
      this.setLineItemButton(this.widget);
    }

    if(this.widget.widgetType === this.widgetTypes.chatView){
     let  mobileData : any = this.sharedSrv.getApplicationDataEntire();
      this.imageUploaderDefault = mobileData.image ;
    }else if(this.widget.widgetType === this.widgetTypes.dataBoard){
      if(!this.widget.widgetConfig?.apiResponce && this.widget.widgetConfig?.dataListWidgetConfig){
        this.makeApiCall(this.widget.widgetDataSource.datasource);
      }
    }else if(this.widget.widgetType === this.widgetTypes.overviewTracker){
      if(this.widget.widgetConfig?.overviewTrackerConfig){
        let statusesColorObj : any = {};
        if(this.widget.widgetConfig.overviewTrackerConfig.statusesColorCode){
          this.widget.widgetConfig.overviewTrackerConfig.statusesColorCode.forEach((statusObj:any) => {
            statusesColorObj[statusObj.status] = {
              bgColor:statusObj.bgColor,
              textcolor:statusObj.textColor
            }
          });
        }
        this.widget.widgetConfig['additionalConfig']['statusesColorObj'] = statusesColorObj;
      }
      if(!this.widget.widgetConfig?.apiResponce && this.widget.widgetConfig?.overviewTrackerConfig){
        this.makeApiCall(this.widget.widgetDataSource.datasource);
      }
    }
    else if(this.widget.widgetType === this.widgetTypes.button){
      this.patchButtonWidget();
    }
     
  }

  async setUpImageUploaderWidget() {
    this.loading = true;
     const image = this.widget.widgetConfig.image;
      if(this.widget.widgetConfig.additionalConfig['imagePath']){
        this.imagePath = this.widget.widgetConfig.additionalConfig['imagePath'];
        this.imageBlob = await this.streamBlobService.fetchImage(this.widget.widgetConfig.additionalConfig['imagePath']);
      } else if(image.includes("mobiwise.s3") ){
        this.widget.widgetConfig.image = this.updateImageUrl(this.widget.widgetConfig.image);
        this.s3imageUrl = this.widget.widgetConfig.image;
      } 
      this.loading = false;
     
  }

  async patchButtonWidget(){
    let action : WIDGETACTION = this.widget.widgetConfig.actions.find((action:WIDGETACTION) => action.action_type === 'lineItem')
    if(action){
      let lineitemConfig = this.widget.widgetConfig.additionalConfig?.lineItemConfig;
      this.initalLineAction = {
        "entityId": lineitemConfig?.entityId,
        "lhsItems": lineitemConfig?.lhsItems,
        "rhsItems": lineitemConfig?.rhsItems,
        "bulk": lineitemConfig?.bulk,
        "table": lineitemConfig?.table,          
      }
      // initial config
      this.renderTemplateview = this.viewMode();
      if(['card','table'].includes(this.renderTemplateview)){
        const currentParams = { ...this.route.snapshot.queryParams };
        const payload = {
          application_id: currentParams['id'],
          entity_id:  this.initalLineAction.entityId,
          project_id: null,
          parent_entity_id: null
        }
  
       const listOfPageWidgetsOfEntity = await this.wpserv.getEntitiesOrAttributes(payload).toPromise();
       let widgetsOfEntity = this.wpserv.retriveWidgetsListFromEntiywithConfig(listOfPageWidgetsOfEntity?.page_widget_details);
       this.lineItemwidgetsMap = {}
       widgetsOfEntity.forEach((widget:any) => {
         this.lineItemwidgetsMap[widget.widgetId] = widget;
       });
      }else{
        await this.getRelatedPageWidgets(action.conditional_clause[0].action);
        this.lineitemPageId = action.conditional_clause[0].action;
      }
    }


      // changes 
      this.wpserv.buttonLineItemConfig$.pipe(takeUntil(this.destroy$)).subscribe((details:any) => {
      if(this.widget.widgetId === details.widgetId){
        // in case action is not present in widget 
        let lineAction = this.widget.widgetConfig.actions.find((action:WIDGETACTION) => action.action_type === this.widgetClickActions.lineItem)
        if(!lineAction)
          this.widget.widgetConfig.actions.push({
            "action_type": this.widgetClickActions.lineItem,
            "conditional_clause": []
        })

        if(!details.pageId){
          this.widget.widgetConfig.actions = this.widget.widgetConfig.actions.filter((action:WIDGETACTION) => action.action_type !== this.widgetClickActions.lineItem)
          return
        }
        if(this.lineitemPageId !== details.pageId){
          this.lineitemPageId = details.pageId;
          this.getRelatedPageWidgets(details.pageId);
        }
        this.lineitemPageId = details.pageId;
        this.lineItemwidgetsMap = {}
        details.widgets.forEach((widget:any) => {
          this.lineItemwidgetsMap[widget.widgetId] = widget;
        });

        this.initalLineAction = structuredClone(details.actionConfig);
        
        this.renderTemplateview = this.viewMode();
        this.cdr.detectChanges();
        
      }
      
    })
  // }
  }

  viewMode(): 'table' | 'card' | 'fallback' {
    const config = this.initalLineAction;
    if (config?.table === true) {
      return 'table';
    }else if (config?.rhsItems.length > 0 || config?.lhsItems.length > 0 || config?.bulk === true) {
      return 'card';
    }else{

      return 'fallback';
    }

  }

  filterAllowedWidgets(widgets:any){
    return widgets.filter((widget:any) => this.allowedWidgetTypes.includes(widget.widgetType))
  }

  getRelatedPageWidgets(pageId:string){
    this.showPagesSpinner = true;
    this.sharedSrv.getPageById(pageId).subscribe({
      next: (responce:any) => {
        let section = responce?.forms.find((form:any) => form.formConfig?.formType === 'section');
        if(section){
          this.relativeWidgets = this.filterAllowedWidgets(section.widgets)
        }
        this.showPagesSpinner = false;
      },
      complete: () => { },
      error: () => {
        this.showPagesSpinner = false;
      }
    })
  }
  
  ngAfterViewInit() {
    if(this.widget.widgetType === this.widgetTypes.imageUploader){
      this.adjustSpinnerSize();
    }
  }

  adjustSpinnerSize() {
    if(this.imageRef){
      const img = this.imageRef.nativeElement;
      if (img) {
        img.onload = () => this.loading = false;
      }
    }
  }
  

  setLineItemButton(widget:any){

    const checkvalid = widget.widgetConfig && widget.widgetConfig.type === "submit";
    if(checkvalid){
      let config = widget.widgetConfig;
      widget.widgetType = this.widgetTypes.button;
    }

  }

  updateImageUrl(image:string) : any {
    // Create a new URL with timestamp or version
    const newImageUrl = `${image}?v=${new Date().getTime()}`;
    
    // Sanitize the URL to prevent security issues
    // return this.sanitizer.bypassSecurityTrustResourceUrl(newImageUrl);
    return newImageUrl;
  }

  onClick(event:any, widgetId: string, sectionIndex: number, widgetIndex: number, widgetMeta: WIDGET) {
    event.preventDefault();
    let selectedPageData: any = this.sharedSrv.getSelectedPage();
    this.sharedSrv.setSelectedOption("Pages", true);
    const allowedPageTypes = [
      pageTypeCnsts.LOGIN,
      pageTypeCnsts.SPLASH_SCREEN,
      pageTypeCnsts.PREVIEW,
    ];
    if (allowedPageTypes.includes(selectedPageData.pageType) || this.widget?.open) {
      return;
    }
    if (this.page.pageId) {
      this.sharedSrv.setPagesExpansionPanelOpener({
        pageID: this.page.pageId,
        sectionIndex: sectionIndex,
        widgetIndex: widgetIndex,
      });
      this.sharedSrv.setSidenavContentlistOption("widget", true);
      this.sharedSrv.onMobileScreenDropUpdateData({
        data: widgetId,
        onClick: true,
        sectionIndex: sectionIndex,
        widgetIndex: widgetIndex,
        widgetMeta: widgetMeta,
      });
    }
  }

  getImageFile() {
    const image = this.widget.widgetConfig.image;
    if(this.widget.widgetConfig.additionalConfig && this.widget.widgetConfig.additionalConfig['imagePath'] && this.imageBlob){
      if(this.imagePath !== this.widget.widgetConfig.additionalConfig['imagePath']){
        this.setUpImageUploaderWidget();
      }
      return this.imageBlob;
    }
    else if (!image || image === "image") {
      return this.imageUploaderDefault;
    }else if(image.includes('mobiwise.s3')){
      if(image !== this.s3imageUrl){
        this.loading = true;
        this.s3imageUrl = image;
      }
      return image;
    }
    else{
      return this.sharedSrv.getModifiedImageUrl(image);
    }
  }

  isRequired(validations: any[]): boolean {
    if (!validations || !Array.isArray(validations)) {
      return false;
    }
    for (const validation of validations) {
      if (validation.validation_type === "Required") {
        return true;
      }
    }
    return false;
  }

  getErrorMessage(validations: any[]): string {
    if (!validations || !Array.isArray(validations)) {
      return "";
    }
    for (const validation of validations) {
      if (validation.validation_type === "Required") {
        return validation.error_message;
      }
    }
    return "";
  }

  loadFont(): void {
    const selectedHeadFont = this.selectedHeadFontFamily.replace(/ /g, "+");
    const selectedBodyFont = this.selectedBodyFamily.replace(/ /g, "+");
    WebFont.load({
      google: {
        families: [
          `${selectedHeadFont}:wght@400`,
          `${selectedBodyFont}:wght@400`,
        ],
      },
    });
  }

  getAvatar() {
    return this.widget.widgetConfig.additionalConfig.uploadedAvatar ?  this.widget.widgetConfig.additionalConfig.uploadedAvatar :  this.defaultAvtarImageUrl;
  }

  async makeApiCall(apiId:string){
    let userDefinedapis = this.apiConfigService.getUserApis()
    let selectedApi = userDefinedapis.apis.find((api:any) => api.apiId === apiId);
    if(!selectedApi){
      let selectedApi = this.preConfiguredApis.find((api:any) => api.apiId === apiId);
      this.widget.widgetConfig['apiResponce'] = selectedApi.apiResponce;
    }else{
      if(selectedApi.authenticatedApiId){
          let authApi = userDefinedapis.authTypeApis.find((api:any) => api.apiId === selectedApi.authenticatedApiId)
          let authResonce:any = await this.apiConfigService.makeDataSourceAuthApiRequest(authApi.apiURL,authApi.method,authApi.requestBody,authApi.headers);
          let token = this.apiConfigService.getValidTokenFromApi(authResonce);
          if(token){
            selectedApi.headers['Authorization'] =  `Bearer ${token}`;
          }
        }
          this.widget.widgetConfig['apiResponce'] = await this.apiConfigService.makeDataSourceApiRequest(
            selectedApi.apiURL,
            selectedApi.method,
            selectedApi.requestBody,
            selectedApi.headers,
          );
        }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete(); 
  }
}
